import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// Layouts
import MainLayout from './components/layout/MainLayout';

// Pages (lazy-loaded for code splitting)
const LandingPage   = lazy(() => import('./pages/LandingPage'));
const JobsPage      = lazy(() => import('./pages/JobsPage'));
const JobDetailPage = lazy(() => import('./pages/JobDetailPage'));
const LoginPage     = lazy(() => import('./pages/LoginPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const DocumentsPage = lazy(() => import('./pages/DocumentsPage'));
const AutoFillPage  = lazy(() => import('./pages/AutoFillPage'));
const PricingPage   = lazy(() => import('./pages/PricingPage'));
const ProfilePage   = lazy(() => import('./pages/ProfilePage'));

function PageLoader() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block w-10 h-10 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
        <p className="mt-3 text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  );
}

export default function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set <html lang> to current language for SEO + accessibility
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/"           element={<LandingPage />} />
          <Route path="/jobs"       element={<JobsPage />} />
          <Route path="/jobs/:id"   element={<JobDetailPage />} />
          <Route path="/pricing"    element={<PricingPage />} />
          <Route path="/login"      element={<LoginPage />} />
          <Route path="/dashboard"  element={<DashboardPage />} />
          <Route path="/profile"    element={<ProfilePage />} />
          <Route path="/documents"  element={<DocumentsPage />} />
          <Route path="/autofill/:taskId" element={<AutoFillPage />} />
          <Route path="*"           element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-navy-800 mb-2">404</h1>
        <p className="text-gray-600">Page not found</p>
      </div>
    </div>
  );
}
